import { useMemo } from 'react';
import uniqueArray from '../utils/uniqueArray';
import utmUrl from '../utils/utmUrl';

const useAggregateContacts = (contactArr = []) => {
  const aggregatContacts = useMemo(() => {
    const contacts = uniqueArray('info', [...contactArr]);

    const filterType = types =>
      contacts.filter(contact => contact.type.match(types));

    const addLink = items =>
      items.map(item => ({
        ...item,
        link: item.info.includes('http')
          ? utmUrl(item.info, {
              medium: 'referral',
              campaign: 'localsearch_advertising',
            })
          : `http://${utmUrl(item.info, {
              medium: 'referral',
              campaign: 'localsearch_advertising',
            })}`,
      }));

    return {
      contacts,
      emails: filterType(/email/gi),
      callNumbers: filterType(/phone|mobile/gi),
      phones: filterType(/phone/gi),
      mobiles: filterType(/mobile/gi),
      faxes: filterType(/fax/gi),
      websites: addLink(filterType(/website/gi)),
    };
  }, [contactArr]);

  return aggregatContacts;
};
export default useAggregateContacts;
